/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfCopyCustomLayerNotificationRequest } from '../models';
// @ts-ignore
import type { BfCustomLayer } from '../models';
// @ts-ignore
import type { BfCustomLayerUpdateRequest } from '../models';
// @ts-ignore
import type { BfMap } from '../models';
// @ts-ignore
import type { FeatureBfCustomData } from '../models';
// @ts-ignore
import type { FeatureCollectionBfCustomData } from '../models';
/**
 * CustomLayersApi - axios parameter creator
 */
export const CustomLayersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Copies a notification to other users within a custom layer
         * @summary Copy a notification
         * @param {string} customLayerId 
         * @param {BfCopyCustomLayerNotificationRequest} bfCopyCustomLayerNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCustomLayerNotification: async (customLayerId: string, bfCopyCustomLayerNotificationRequest: BfCopyCustomLayerNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('copyCustomLayerNotification', 'customLayerId', customLayerId)
            // verify required parameter 'bfCopyCustomLayerNotificationRequest' is not null or undefined
            assertParamExists('copyCustomLayerNotification', 'bfCopyCustomLayerNotificationRequest', bfCopyCustomLayerNotificationRequest)
            const localVarPath = `/v1/customlayers/layers/{customLayerId}/copy`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfCopyCustomLayerNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new custom layer with defaults
         * @summary Create custom layer
         * @param {string} [name] Name of the custom layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomLayer: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/customlayers/layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new feature within a custom layer
         * @summary Create a feature
         * @param {string} customLayerId 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomLayerFeature: async (customLayerId: string, featureBfCustomData: FeatureBfCustomData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('createCustomLayerFeature', 'customLayerId', customLayerId)
            // verify required parameter 'featureBfCustomData' is not null or undefined
            assertParamExists('createCustomLayerFeature', 'featureBfCustomData', featureBfCustomData)
            const localVarPath = `/v1/customlayers/layers/data/{customLayerId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureBfCustomData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the client config for the given client
         * @summary Map configuration for custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customLayerConfig: async (customLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('customLayerConfig', 'customLayerId', customLayerId)
            const localVarPath = `/v1/customlayers/map/{customLayerId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the custom layer
         * @summary Delete custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayer: async (customLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('deleteCustomLayer', 'customLayerId', customLayerId)
            const localVarPath = `/v1/customlayers/layers/{customLayerId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a feature within a custom layer
         * @summary Delete a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayerFeature: async (customLayerId: string, eKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('deleteCustomLayerFeature', 'customLayerId', customLayerId)
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('deleteCustomLayerFeature', 'eKey', eKey)
            const localVarPath = `/v1/customlayers/layers/data/{customLayerId}/{eKey}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)))
                .replace(`{${"eKey"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a notification from a custom layer
         * @summary Delete a notification by id
         * @param {string} customLayerId 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayerNotification: async (customLayerId: string, notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('deleteCustomLayerNotification', 'customLayerId', customLayerId)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteCustomLayerNotification', 'notificationId', notificationId)
            const localVarPath = `/v1/customlayers/layers/{customLayerId}/notifications/{notificationId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)))
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a particular custom layer
         * @summary Get custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayer: async (customLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('getCustomLayer', 'customLayerId', customLayerId)
            const localVarPath = `/v1/customlayers/layers/{customLayerId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets data for a particular custom layer
         * @summary Get custom layer data
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayerData: async (customLayerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('getCustomLayerData', 'customLayerId', customLayerId)
            const localVarPath = `/v1/customlayers/layers/data/{customLayerId}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a particular feature from a custom layer
         * @summary Get feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayerFeature: async (customLayerId: string, eKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('getCustomLayerFeature', 'customLayerId', customLayerId)
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('getCustomLayerFeature', 'eKey', eKey)
            const localVarPath = `/v1/customlayers/layers/data/{customLayerId}/{eKey}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)))
                .replace(`{${"eKey"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current custom layers available
         * @summary List custom layers
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomLayers: async (userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/customlayers/layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Either updates the feature collection, notifications or the layer definitions. Multiple requests are required to update each of these.
         * @summary Update custom layer
         * @param {BfCustomLayerUpdateRequest} bfCustomLayerUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomLayer: async (bfCustomLayerUpdateRequest: BfCustomLayerUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfCustomLayerUpdateRequest' is not null or undefined
            assertParamExists('updateCustomLayer', 'bfCustomLayerUpdateRequest', bfCustomLayerUpdateRequest)
            const localVarPath = `/v1/customlayers/layers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfCustomLayerUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a feature within a custom layer
         * @summary Update a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomLayerFeature: async (customLayerId: string, eKey: string, featureBfCustomData: FeatureBfCustomData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customLayerId' is not null or undefined
            assertParamExists('updateCustomLayerFeature', 'customLayerId', customLayerId)
            // verify required parameter 'eKey' is not null or undefined
            assertParamExists('updateCustomLayerFeature', 'eKey', eKey)
            // verify required parameter 'featureBfCustomData' is not null or undefined
            assertParamExists('updateCustomLayerFeature', 'featureBfCustomData', featureBfCustomData)
            const localVarPath = `/v1/customlayers/layers/data/{customLayerId}/{eKey}`
                .replace(`{${"customLayerId"}}`, encodeURIComponent(String(customLayerId)))
                .replace(`{${"eKey"}}`, encodeURIComponent(String(eKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureBfCustomData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomLayersApi - functional programming interface
 */
export const CustomLayersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomLayersApiAxiosParamCreator(configuration)
    return {
        /**
         * Copies a notification to other users within a custom layer
         * @summary Copy a notification
         * @param {string} customLayerId 
         * @param {BfCopyCustomLayerNotificationRequest} bfCopyCustomLayerNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async copyCustomLayerNotification(customLayerId: string, bfCopyCustomLayerNotificationRequest: BfCopyCustomLayerNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfCustomLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.copyCustomLayerNotification(customLayerId, bfCopyCustomLayerNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.copyCustomLayerNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new custom layer with defaults
         * @summary Create custom layer
         * @param {string} [name] Name of the custom layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomLayer(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomLayer(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.createCustomLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new feature within a custom layer
         * @summary Create a feature
         * @param {string} customLayerId 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomLayerFeature(customLayerId: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomLayerFeature(customLayerId, featureBfCustomData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.createCustomLayerFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the client config for the given client
         * @summary Map configuration for custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customLayerConfig(customLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customLayerConfig(customLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.customLayerConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes the custom layer
         * @summary Delete custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomLayer(customLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.deleteCustomLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a feature within a custom layer
         * @summary Delete a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomLayerFeature(customLayerId, eKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.deleteCustomLayerFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a notification from a custom layer
         * @summary Delete a notification by id
         * @param {string} customLayerId 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomLayerNotification(customLayerId: string, notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfCustomLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomLayerNotification(customLayerId, notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.deleteCustomLayerNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a particular custom layer
         * @summary Get custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfCustomLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomLayer(customLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.getCustomLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets data for a particular custom layer
         * @summary Get custom layer data
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomLayerData(customLayerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCollectionBfCustomData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomLayerData(customLayerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.getCustomLayerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a particular feature from a custom layer
         * @summary Get feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureBfCustomData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomLayerFeature(customLayerId, eKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.getCustomLayerFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the current custom layers available
         * @summary List custom layers
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomLayers(userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfCustomLayer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomLayers(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.listCustomLayers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Either updates the feature collection, notifications or the layer definitions. Multiple requests are required to update each of these.
         * @summary Update custom layer
         * @param {BfCustomLayerUpdateRequest} bfCustomLayerUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomLayer(bfCustomLayerUpdateRequest: BfCustomLayerUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfCustomLayer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomLayer(bfCustomLayerUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.updateCustomLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a feature within a custom layer
         * @summary Update a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomLayerFeature(customLayerId: string, eKey: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomLayerFeature(customLayerId, eKey, featureBfCustomData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomLayersApi.updateCustomLayerFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomLayersApi - factory interface
 */
export const CustomLayersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomLayersApiFp(configuration)
    return {
        /**
         * Copies a notification to other users within a custom layer
         * @summary Copy a notification
         * @param {string} customLayerId 
         * @param {BfCopyCustomLayerNotificationRequest} bfCopyCustomLayerNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyCustomLayerNotification(customLayerId: string, bfCopyCustomLayerNotificationRequest: BfCopyCustomLayerNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfCustomLayer> {
            return localVarFp.copyCustomLayerNotification(customLayerId, bfCopyCustomLayerNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new custom layer with defaults
         * @summary Create custom layer
         * @param {string} [name] Name of the custom layer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomLayer(name?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createCustomLayer(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new feature within a custom layer
         * @summary Create a feature
         * @param {string} customLayerId 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomLayerFeature(customLayerId: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.createCustomLayerFeature(customLayerId, featureBfCustomData, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the client config for the given client
         * @summary Map configuration for custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customLayerConfig(customLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfMap> {
            return localVarFp.customLayerConfig(customLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the custom layer
         * @summary Delete custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteCustomLayer(customLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a feature within a custom layer
         * @summary Delete a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteCustomLayerFeature(customLayerId, eKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a notification from a custom layer
         * @summary Delete a notification by id
         * @param {string} customLayerId 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomLayerNotification(customLayerId: string, notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfCustomLayer> {
            return localVarFp.deleteCustomLayerNotification(customLayerId, notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a particular custom layer
         * @summary Get custom layer
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<BfCustomLayer> {
            return localVarFp.getCustomLayer(customLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets data for a particular custom layer
         * @summary Get custom layer data
         * @param {string} customLayerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayerData(customLayerId: string, options?: RawAxiosRequestConfig): AxiosPromise<FeatureCollectionBfCustomData> {
            return localVarFp.getCustomLayerData(customLayerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a particular feature from a custom layer
         * @summary Get feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig): AxiosPromise<FeatureBfCustomData> {
            return localVarFp.getCustomLayerFeature(customLayerId, eKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current custom layers available
         * @summary List custom layers
         * @param {string} [userId] User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomLayers(userId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BfCustomLayer>> {
            return localVarFp.listCustomLayers(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Either updates the feature collection, notifications or the layer definitions. Multiple requests are required to update each of these.
         * @summary Update custom layer
         * @param {BfCustomLayerUpdateRequest} bfCustomLayerUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomLayer(bfCustomLayerUpdateRequest: BfCustomLayerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfCustomLayer> {
            return localVarFp.updateCustomLayer(bfCustomLayerUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a feature within a custom layer
         * @summary Update a feature
         * @param {string} customLayerId 
         * @param {string} eKey 
         * @param {FeatureBfCustomData} featureBfCustomData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomLayerFeature(customLayerId: string, eKey: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateCustomLayerFeature(customLayerId, eKey, featureBfCustomData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomLayersApi - object-oriented interface
 */
export class CustomLayersApi extends BaseAPI {
    /**
     * Copies a notification to other users within a custom layer
     * @summary Copy a notification
     * @param {string} customLayerId 
     * @param {BfCopyCustomLayerNotificationRequest} bfCopyCustomLayerNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public copyCustomLayerNotification(customLayerId: string, bfCopyCustomLayerNotificationRequest: BfCopyCustomLayerNotificationRequest, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).copyCustomLayerNotification(customLayerId, bfCopyCustomLayerNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new custom layer with defaults
     * @summary Create custom layer
     * @param {string} [name] Name of the custom layer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCustomLayer(name?: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).createCustomLayer(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new feature within a custom layer
     * @summary Create a feature
     * @param {string} customLayerId 
     * @param {FeatureBfCustomData} featureBfCustomData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCustomLayerFeature(customLayerId: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).createCustomLayerFeature(customLayerId, featureBfCustomData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the client config for the given client
     * @summary Map configuration for custom layer
     * @param {string} customLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customLayerConfig(customLayerId: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).customLayerConfig(customLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the custom layer
     * @summary Delete custom layer
     * @param {string} customLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).deleteCustomLayer(customLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a feature within a custom layer
     * @summary Delete a feature
     * @param {string} customLayerId 
     * @param {string} eKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).deleteCustomLayerFeature(customLayerId, eKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a notification from a custom layer
     * @summary Delete a notification by id
     * @param {string} customLayerId 
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCustomLayerNotification(customLayerId: string, notificationId: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).deleteCustomLayerNotification(customLayerId, notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a particular custom layer
     * @summary Get custom layer
     * @param {string} customLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomLayer(customLayerId: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).getCustomLayer(customLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets data for a particular custom layer
     * @summary Get custom layer data
     * @param {string} customLayerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomLayerData(customLayerId: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).getCustomLayerData(customLayerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a particular feature from a custom layer
     * @summary Get feature
     * @param {string} customLayerId 
     * @param {string} eKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomLayerFeature(customLayerId: string, eKey: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).getCustomLayerFeature(customLayerId, eKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current custom layers available
     * @summary List custom layers
     * @param {string} [userId] User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCustomLayers(userId?: string, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).listCustomLayers(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Either updates the feature collection, notifications or the layer definitions. Multiple requests are required to update each of these.
     * @summary Update custom layer
     * @param {BfCustomLayerUpdateRequest} bfCustomLayerUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomLayer(bfCustomLayerUpdateRequest: BfCustomLayerUpdateRequest, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).updateCustomLayer(bfCustomLayerUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a feature within a custom layer
     * @summary Update a feature
     * @param {string} customLayerId 
     * @param {string} eKey 
     * @param {FeatureBfCustomData} featureBfCustomData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomLayerFeature(customLayerId: string, eKey: string, featureBfCustomData: FeatureBfCustomData, options?: RawAxiosRequestConfig) {
        return CustomLayersApiFp(this.configuration).updateCustomLayerFeature(customLayerId, eKey, featureBfCustomData, options).then((request) => request(this.axios, this.basePath));
    }
}

